/* ============================================
   CANDLE HOMEPAGE — Interactive Scripts
   For Shopify Section
   ============================================ */

/* ============================================
   SARYU DECOR — Interactive Scripts
   ============================================ */

(function () {
  'use strict';

  function initHomepageScripts() {
    // PAGE LOADER
    window.addEventListener('load', () => {
      const loader = document.getElementById('pageLoader');
      if (loader) {
        setTimeout(() => {
          loader.classList.add('loaded');
          setTimeout(() => initScrollReveal(), 100);
        }, 100);
      } else {
        initScrollReveal();
      }
    });

    // HEADER (optional)
    const header = document.getElementById('mainHeader');
    let lastScrollY = 0;
    let headerHidden = false;

    function handleHeaderScroll() {
      if (!header) return;

      const currentScrollY = window.scrollY;

      if (currentScrollY > 10) header.classList.add('header--scrolled');
      else header.classList.remove('header--scrolled');

      if (currentScrollY > 300) {
        if (currentScrollY > lastScrollY && !headerHidden) {
          header.classList.add('header--hidden');
          headerHidden = true;
        } else if (currentScrollY < lastScrollY && headerHidden) {
          header.classList.remove('header--hidden');
          headerHidden = false;
        }
      } else {
        header.classList.remove('header--hidden');
        headerHidden = false;
      }

      lastScrollY = currentScrollY;
    }

    if (header) {
      window.addEventListener('scroll', handleHeaderScroll, { passive: true });
      handleHeaderScroll();
    }

    // MOBILE MENU (optional)
    const menuToggle = document.getElementById('menuToggle');
    const mobileMenu = document.getElementById('mobileMenu');

    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', () => {
        menuToggle.classList.toggle('active');
        mobileMenu.classList.toggle('open');
        document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
      });

      const expandableItems = mobileMenu.querySelectorAll('[data-expandable]');
      expandableItems.forEach(item => {
        const link = item.querySelector('.mobile-menu__link');
        if (link) {
          link.addEventListener('click', (e) => {
            e.preventDefault();
            item.classList.toggle('open');
          });
        }
      });

      const mobileLinks = mobileMenu.querySelectorAll(
        '.mobile-menu__sub-link, .mobile-menu__item:not([data-expandable]) .mobile-menu__link'
      );

      mobileLinks.forEach(link => {
        link.addEventListener('click', () => {
          menuToggle.classList.remove('active');
          mobileMenu.classList.remove('open');
          document.body.style.overflow = '';
        });
      });
    }

    // SCROLL REVEAL
    function initScrollReveal() {
      const revealElements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('revealed');
              observer.unobserve(entry.target);
            }
          });
        }, {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
        });

        revealElements.forEach(el => observer.observe(el));
      } else {
        revealElements.forEach(el => el.classList.add('revealed'));
      }
    }

    // HERO PARALLAX (optional)
    const heroImage = document.getElementById('heroImage');
    const heroSection = document.getElementById('heroSection');

    function handleParallax() {
      if (!heroImage || !heroSection) return;

      const scrollY = window.scrollY;
      const heroHeight = heroSection.offsetHeight;

      if (scrollY < heroHeight) {
        const parallaxOffset = scrollY * 0.4;
        heroImage.style.transform = `translateY(${parallaxOffset}px) scale(1.05)`;
      }
    }

    if (heroImage && heroSection) {
      window.addEventListener('scroll', handleParallax, { passive: true });
      handleParallax();
    }

    // BACK TO TOP (optional)
    const backToTop = document.getElementById('backToTop');

    function handleBackToTopVisibility() {
      if (!backToTop) return;
      if (window.scrollY > 600) backToTop.classList.add('visible');
      else backToTop.classList.remove('visible');
    }

    if (backToTop) {
      window.addEventListener('scroll', handleBackToTopVisibility, { passive: true });
      handleBackToTopVisibility();

      backToTop.addEventListener('click', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    // NEWSLETTER FORM
    const newsletterForm = document.getElementById('newsletterForm');
    const newsletterEmail = document.getElementById('newsletterEmail');

    if (newsletterForm && newsletterEmail) {
      newsletterForm.addEventListener('submit', (e) => {
        e.preventDefault();
        const email = newsletterEmail.value.trim();

        if (email) {
          const submitBtn = newsletterForm.querySelector('.newsletter__submit');
          if (!submitBtn) return;

          const originalText = submitBtn.textContent;
          submitBtn.textContent = '✓ Subscribed!';
          submitBtn.style.background = '#25D366';
          newsletterEmail.value = '';

          setTimeout(() => {
            submitBtn.textContent = originalText;
            submitBtn.style.background = '';
          }, 3000);
        }
      });
    }

    // SMOOTH SCROLL
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        const targetId = anchor.getAttribute('href');
        if (!targetId || targetId === '#') return;

        const target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          const headerOffset = header ? header.offsetHeight + 20 : 20;
          const elementPosition = target.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.scrollY - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      });
    });

    // WISHLIST TOGGLE
    document.querySelectorAll('.product-card__wishlist').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const svg = btn.querySelector('svg');
        const isActive = btn.classList.toggle('active');

        if (svg) {
          if (isActive) {
            svg.setAttribute('fill', '#C25550');
            svg.style.color = '#C25550';
            btn.style.transform = 'scale(1.3)';
            setTimeout(() => {
              btn.style.transform = 'scale(1)';
            }, 200);
          } else {
            svg.setAttribute('fill', 'none');
            svg.style.color = '';
          }
        }
      });
    });

    // QUICK ADD
    document.querySelectorAll('.product-card__quick-add').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const originalText = btn.textContent;
        btn.textContent = '✓ Added!';
        btn.style.background = '#25D366';

        const cartCount = document.querySelector('.header__cart-count');
        if (cartCount) {
          const currentCount = parseInt(cartCount.textContent) || 0;
          cartCount.textContent = currentCount + 1;
          cartCount.style.transform = 'scale(1.4)';
          setTimeout(() => {
            cartCount.style.transform = 'scale(1)';
          }, 300);
        }

        setTimeout(() => {
          btn.textContent = originalText;
          btn.style.background = '';
        }, 1500);
      });
    });

    // MEGA MENU ACCESSIBILITY
    document.querySelectorAll('.nav__item').forEach(item => {
      const link = item.querySelector('.nav__link');
      const megaMenu = item.querySelector('.mega-menu');

      if (link && megaMenu) {
        item.addEventListener('focusin', () => {
          megaMenu.style.opacity = '1';
          megaMenu.style.visibility = 'visible';
          megaMenu.style.pointerEvents = 'auto';
          megaMenu.style.transform = 'translateX(-50%) translateY(0)';
        });

        item.addEventListener('focusout', (e) => {
          if (!item.contains(e.relatedTarget)) {
            megaMenu.style.opacity = '';
            megaMenu.style.visibility = '';
            megaMenu.style.pointerEvents = '';
            megaMenu.style.transform = '';
          }
        });
      }
    });

    // LAZY LOAD IMAGES
    if ('IntersectionObserver' in window) {
      const lazyImages = document.querySelectorAll('img[data-src]');
      const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.addEventListener('load', () => img.classList.add('loaded'));
            imageObserver.unobserve(img);
          }
        });
      }, {
        rootMargin: '200px 0px'
      });

      lazyImages.forEach(img => imageObserver.observe(img));
    }

    // CURSOR TRAIL
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      const cursor = document.createElement('div');
      cursor.classList.add('cursor-dot');
      document.body.appendChild(cursor);

      let mouseX = 0, mouseY = 0;
      let cursorX = 0, cursorY = 0;

      document.addEventListener('mousemove', (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;
      });

      function animateCursor() {
        cursorX += (mouseX - cursorX) * 0.15;
        cursorY += (mouseY - cursorY) * 0.15;
        cursor.style.left = cursorX + 'px';
        cursor.style.top = cursorY + 'px';
        requestAnimationFrame(animateCursor);
      }

      animateCursor();
    }

    // SEARCH BUTTON
    const searchBtn = document.getElementById('searchBtn');
    if (searchBtn) {
      searchBtn.addEventListener('click', () => {
        alert('Search coming soon! 🔍');
      });
    }

    // PRELOAD IMAGE
    const img = new Image();
    img.src = 'assets/images/hero-candle.png';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomepageScripts);
  } else {
    initHomepageScripts();
  }
})();